import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import hkLocale from 'element-ui/lib/locale/lang/zh-TW'
import zhCN from './zhCN'
import zhHK from './zhHK'
import store from '../store/store'
Vue.use(VueI18n)

let i18n = new VueI18n({
  locale: store.state.lang || 'zhCN',
  messages: {
    'zhCN': {
      ...zhCN,
      ...zhLocale
    },
    'zhHK': {
      ...zhHK,
      ...hkLocale
    }
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js